<template>
  <span>
    <v-text-field
      v-if="editing"
      :disabled="disabled"
      :maxlength="maxlength"
      :value="password ? '' : text"
      @change="changed"
      :rules="all_rules"
      :label="label"
      ref="atinput"
      validate-on-blur
      @focusout.native="blur"
      :autofocus="autofocus"
    ></v-text-field>
    <span v-else>
      <span v-if="hasTooltip">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ trxtext }}</span>
          </template>
          {{ tooltip }}
        </v-tooltip>
      </span>
      <span v-else-if="password">•••••••</span>
      <span v-else>{{ trxtext }}</span>
    </span>
  </span>
</template>

<script>
import ATInputMixin from "./ATInputMixin.js";

const email_check_pattern = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  mixins: [ATInputMixin],
  computed: {
    all_rules() {
      let rules = [];
      if (this.required) rules.push(value => !!value || "Required.");
      if (this.email)
        rules.push(
          value =>
            email_check_pattern.test(value) ||
            value === undefined ||
            "Invalid e-mail"
        );
      return rules;
    }
  }
};
</script>